import { useEffect, useState } from "react";
import { Plus, Save, Trash2, Pencil, X, Tags, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../api";
import { useAuth } from "../auth";

export default function Categories() {
  const { can } = useAuth();
  const editable = can("admin", "project_manager");
  const [items, setItems] = useState([]);
  const [used, setUsed] = useState([]);
  const [newName, setNewName] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  const load = () => api.get("/work-items/categories").then((r) => { setItems(r.data.managed || []); setUsed(r.data.custom || []); }).catch(() => toast.error("Kategoriler yüklenemedi"));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    try { await api.post("/work-items/categories", { name: newName.trim() }); toast.success("Kategori eklendi"); setNewName(""); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const saveEdit = async (id) => {
    if (!editName.trim()) return;
    try { await api.put(`/work-items/categories/${id}`, { name: editName.trim() }); toast.success("Kategori güncellendi (tüm projelerde)"); setEditId(null); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (c) => {
    if (c.work_item_count > 0) {
      toast.error(`"${c.name}" ${c.projects.length} projede kullanılıyor: ${c.projects.slice(0, 4).join(", ")}${c.projects.length > 4 ? " …" : ""}`);
      return;
    }
    if (!window.confirm(`"${c.name}" kategorisi silinsin mi?`)) return;
    try { await api.delete(`/work-items/categories/${c.id}`); toast.success("Kategori silindi"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <main className="content" data-testid="page-categories">
      <div className="page-head">
        <div>
          <span className="section-kicker">İŞ KALEMİ KATEGORİLERİ</span>
          <h1>Kategori Yönetimi ({items.length})</h1>
          <p>İş kalemi kategorilerini ekleyin veya yeniden adlandırın. Yeniden adlandırma tüm projelere yansır. Bir projede kullanılan kategori silinemez; yalnızca boş (kullanılmayan) kategoriler silinebilir.</p>
        </div>
      </div>

      {editable && (
        <form className="filter-bar" onSubmit={add}>
          <div className="search-wrap" style={{ maxWidth: 380 }}><Tags size={15} /><input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="Yeni kategori (ör. Saha Geliştirme)" data-testid="category-new-input" /></div>
          <button className="new-btn" type="submit" data-testid="category-add-button"><Plus size={16} /> Kategori Ekle</button>
        </form>
      )}

      <section className="panel">
        <div className="project-table" data-testid="category-list">
          <div className="table-row table-head cat-table-row"><span>KATEGORİ</span><span>DURUM</span><span>KULLANILAN PROJELER</span><span></span></div>
          {items.map((c) => (
            <div className="table-row cat-table-row" key={c.id} data-testid={`category-row-${c.name}`}>
              {editId === c.id ? (
                <div className="cat-edit-inline">
                  <input value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus data-testid="category-edit-input" />
                  <button className="row-action" onClick={() => saveEdit(c.id)} data-testid={`category-save-${c.name}`}><Save size={15} /></button>
                  <button className="row-action" onClick={() => setEditId(null)}><X size={15} /></button>
                </div>
              ) : (
                <b className="wi-cat">{c.name}</b>
              )}
              <span>{c.work_item_count > 0 ? <em className="status status-amber">{c.work_item_count} iş kalemi</em> : <em className="status status-green">Boş</em>}</span>
              <small className="cat-projects-cell" title={c.projects?.join(", ")}>{c.projects?.length ? c.projects.join(" · ") : "—"}</small>
              {editable && editId !== c.id ? (
                <div className="row-actions">
                  <button className="row-action" onClick={() => { setEditId(c.id); setEditName(c.name); }} data-testid={`category-edit-${c.name}`}><Pencil size={13} /></button>
                  <button className={`row-action ${c.work_item_count > 0 ? "disabled" : "danger"}`} disabled={c.work_item_count > 0} title={c.work_item_count > 0 ? "Kullanımda, silinemez" : "Sil"} onClick={() => remove(c)} data-testid={`category-delete-${c.name}`}><Trash2 size={13} /></button>
                </div>
              ) : <span />}
            </div>
          ))}
          {!items.length && <div className="empty-hint">Kategori yok. Yukarıdan ekleyin.</div>}
        </div>

        {used.length > 0 && (
          <div className="cat-used">
            <span className="eyebrow"><AlertTriangle size={11} style={{ verticalAlign: "-1px", marginRight: 4 }} />LİSTEDE OLMAYAN AMA PROJELERDE KULLANILAN</span>
            <p>{used.join(" · ")}</p>
          </div>
        )}
      </section>
    </main>
  );
}
